import lottie from "lottie-web"

declare var $

export class LottiePlayer {
  el: HTMLElement
  animData: JSON

  constructor(el, animData) {
    this.el = el
    this.animData = animData
    this.buildLottie()
  }

  buildLottie() {
    let instance = lottie.loadAnimation({
      container: this.el,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      animationData: this.animData
    })
    instance.setSpeed(3)
    $(this.el).data('instance', instance)
  }

}